import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=628971ce"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"
import style0 from "./ModelDetails.vue?vue&type=style&index=0&id=628971ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports